import * as types from "./types";

const mutations = {
    [types.LOADING_VEHICLE](state, value) {
        state.loading = value;
    },
    [types.GET_VEHICLE_LIST](state, vehicles) {
        state.vehicles = vehicles;
    },
    [types.REMOVE_VEHICLE](state, id) {        
        state.vehicles = state.vehicles.filter((x) => x.id !== id);        
    },
    [types.ADD_VEHICLE](state, vehicle) {        
        state.vehicles.unshift(vehicle);
    },
    [types.UPDATE_VEHICLE](state, vehicle) {        
        const gpsdeviceIndex = state.vehicles.findIndex((x) => x.id === vehicle.id);
        state.vehicles[gpsdeviceIndex] = vehicle;        
    },
    [types.GET_VEHICLEBYID](state, vehicleId) {
        state.vehicleId = vehicleId;
    }
};

export default mutations;